function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import DarkMixin from '../../mixins/dark.js';
import ListenersMixin from '../../mixins/listeners.js';
import { slot } from '../../utils/slot.js';
export default Vue.extend({
  name: 'QTimeline',
  mixins: [DarkMixin, ListenersMixin],
  provide: function provide() {
    return {
      __timeline: this
    };
  },
  props: {
    color: {
      type: String,
      "default": 'primary'
    },
    side: {
      type: String,
      "default": 'right',
      validator: function validator(v) {
        return ['left', 'right'].includes(v);
      }
    },
    layout: {
      type: String,
      "default": 'dense',
      validator: function validator(v) {
        return ['dense', 'comfortable', 'loose'].includes(v);
      }
    }
  },
  computed: {
    classes: function classes() {
      return "q-timeline--".concat(this.layout, " q-timeline--").concat(this.layout, "--").concat(this.side) + (this.isDark === true ? ' q-timeline--dark' : '');
    }
  },
  render: function render(h) {
    return h('ul', {
      staticClass: 'q-timeline',
      "class": this.classes,
      on: _objectSpread({}, this.qListeners)
    }, slot(this, 'default'));
  }
});